import { useEffect, useState } from 'react';
import { getFirebaseStatus } from '@/infrastructure/firebase/firebaseStatus.js';
import { useAppStore } from '@/stores/useAppStore.js';
import { AppMode } from '@k-ucap/shared';

export const useAppMode = () => {
  const [mode, setMode] = useState<AppMode>(AppMode.MOCK);
  const setStoreMode = useAppStore((s) => s.setMode);

  useEffect(() => {
    const status = getFirebaseStatus();
    setMode(status.mode);
    setStoreMode(status.mode);
  }, [setStoreMode]);

  return mode;
};
